import React from 'react'

export const data = [
  {
    id: 1,
    color: 'grey',
    title: '12.09.2001',
    description: null,
    image: 'une-1209.jpg',
    html: null,
    link: null,
    offset: 0
  },
  {
    id: 2,
    color: 'grey',
    title: '12.09.2001',
    description: "L'attentat le plus monstrueux de l'histoire",
    image: 'p2-1209.jpg',
    html: null,
    link: '795836002811',
    offset: -2
  },
  {
    id: 3,
    color: 'grey',
    title: null,
    description: null,
    image: 'p3-1209.jpg',
    html: null,
    link: null,
    offset: -2
  },
  {
    id: 4,
    color: 'grey',
    title: 'Dominique von Burg',
    description: 'Face à l’horreur de l’attentat, la peur d’écrire des banalités',
    image: 'expert-2.jpg',
    html: null,
    link: '998881652761',
    offset: 2
  },
  {
    id: 5,
    color: 'grey',
    title: '13.09.2001',
    description: null,
    image: 'une-1309.jpg',
    html: null,
    link: null,
    offset: 0
  },
  {
    id: 6,
    color: 'grey',
    title: '13.09.2001',
    description: "«Je t'appelle de l'avion. Je veux que tu saches que je t'aime...»",
    image: 'p6-1309.jpg',
    html: null,
    link: '985219234293',
    offset: -2
  },
  {
    id: 7,
    color: 'grey',
    title: '14.09.2001',
    description: null,
    image: 'une-1409.jpg',
    html: null,
    link: null,
    offset: 0
  },
  {
    id: 8,
    color: 'grey',
    title: '14.09.2001',
    description: "Washington place ben Laden dans sa ligne de mire",
    image: 'p6-1409.jpg',
    html: null,
    link: '514010169268',
    offset: -2
  },
  {
    id: 9,
    color: 'grey',
    title: 'Ester Paredes',
    description: "Une photo de Une pour mettre en avant le drame humain",
    image: 'expert-3.jpg',
    html: null,
    link: '559629829138',
    offset: 2
  },
  {
    id: 10,
    color: 'grey',
    title: '15-16.09.2001',
    description: null,
    image: 'une-15-1609.jpg',
    html: null,
    link: null,
    offset: 0
  },
  {
    id: 11,
    color: 'grey',
    title: '15-16.09.2001',
    description: "Des Genevois s'activent toujours à la recherche de leurs proches",
    image: 'p6-15-1609.jpg',
    html: null,
    link: '936547363665',
    offset: -2
  },
  {
    id: 12,
    color: 'grey',
    title: '17.09.2001',
    description: null,
    image: 'une-1709.jpg',
    html: null,
    link: null,
    offset: 0
  },
  {
    id: 13,
    color: 'grey',
    title: '17.09.2001',
    description: "À New York, l'espoir diminue, pas l'acharnement",
    image: 'p2-1709.jpg',
    html: null,
    link: '932861100878',
    offset: -2
  },
  {
    id: 14,
    color: 'grey',
    title: 'Pierre Ruetschi',
    description: "Les attentats le tirent de ses vacances en Corse",
    image: 'expert-4.jpg',
    html: null,
    link: '271735332393',
    offset: 2
  },
  {
    id: 15,
    color: 'yellow',
    title: '18.09.2001',
    description: null,
    image: 'une-1809.jpg',
    html: null,
    link: null,
    offset: 0
  },
  {
    id: 16,
    color: 'grey',
    title: '18.09.2001',
    description: "«Ben Laden a inventé le terrorisme coté en Bourse»",
    image: 'p8-1809.jpg',
    html: null,
    link: '892338065556',
    offset: -2
  },
  {
    id: 17,
    color: 'yellow',
    title: '19.09.2001',
    description: null,
    image: 'une-1909.jpg',
    html: null,
    link: null,
    offset: 0
  },
  {
    id: 18,
    color: 'grey',
    title: '19.09.2001',
    description: "Les premiers pas de l'enquête soulignent les erreurs du FBI",
    image: 'p6-1909.jpg',
    html: null,
    link: '934147898282',
    offset: -2
  }
]
